"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolverCenter(_a) {
    var trigger = _a.trigger, content = _a.content, viewport = _a.viewport;
    var left = trigger.leftUpAnchor.x + trigger.width / 2 - content.width / 2;
    var top = trigger.leftUpAnchor.y + trigger.height / 2 - content.height / 2;
    if (left > 0 &&
        left + content.width <= viewport.width &&
        top > 0 &&
        top + content.height <= viewport.height) {
        return {
            left: left,
            top: top,
        };
    }
    return false;
}
exports.default = resolverCenter;
//# sourceMappingURL=resolverCenter.js.map